import { render, staticRenderFns } from "./NewAutoInvoice.vue?vue&type=template&id=2c5c9e06&scoped=true&"
import script from "./NewAutoInvoice.vue?vue&type=script&lang=js&"
export * from "./NewAutoInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewAutoInvoice.vue?vue&type=style&index=0&id=2c5c9e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c9e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5c9e06')) {
      api.createRecord('2c5c9e06', component.options)
    } else {
      api.reload('2c5c9e06', component.options)
    }
    module.hot.accept("./NewAutoInvoice.vue?vue&type=template&id=2c5c9e06&scoped=true&", function () {
      api.rerender('2c5c9e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/NewAutoInvoice.vue"
export default component.exports